(function ($) {

    const baseClassForOverlayEl = 'highlight-table-col-overlay';

    const mediumMediaQueryList = window.matchMedia("(min-width: 768px)");
    let isMediumBreakpoint = mediumMediaQueryList.matches;

    let debounceResizeTimeout = null;
    let $blocksWithTablesToHighlight = null;


    /*
    on screen resize - if breakpoint will be changed (from desktop down to 768, or from 0 to 768) - checkIfMediumBreakpoint() function
    will be executed and mediumMediaQueryList.matches variable will have Boolean val which
        - if it has "true" value - current breakpoint is medium or higher
        - if it has "false" value - current breakpoint is below medium (mobile screens)

     */
    mediumMediaQueryList.addEventListener?.("change", checkIfMediumBreakpoint) || mediumMediaQueryList.addListener(checkIfMediumBreakpoint);


    function checkIfMediumBreakpoint() {
        isMediumBreakpoint = mediumMediaQueryList.matches;
    }


    function deleteHighlightOverlaysForTables() {
        $('.' + baseClassForOverlayEl).remove();
    }


    function initializeHighlightOverlaysForTables(noAnimations = false) {
        if (!isMediumBreakpoint) return;


        // saving blocks with tables to highlight to avoid DOM search every resize / rebuild
        if (!$blocksWithTablesToHighlight) {
            $blocksWithTablesToHighlight = $('.highlight-table-cols');
        }

        $blocksWithTablesToHighlight.each(function () {

            const $this = $(this);
            const $table = $this.find('table');

            const $checkBorderWidthEl = $this.find( '.' + $this.data('check-border-el-with-class') );
            const checkedTableWrapBorderWidth = $checkBorderWidthEl.length
                ? parseInt($this.find( '.' + $this.data('check-border-el-with-class') ).css('border-width'))
                : null;

            deleteHighlightOverlaysForTables();

            // if we set custom classes that need to added along with baseClassForOverlayEl
            const overlayElCustomClasses = $this.data('overlay-el-custom-class') + (noAnimations ? (` ${baseClassForOverlayEl}--no-animations`) : '');

            // if we set a gap that needs to be between overlay elements
            const overlayElGap = parseInt($this.data('overlays-el-gap'));


            const thisBoundingClientRect = $this.get(0).getBoundingClientRect();
            const tableContentHeight = thisBoundingClientRect.height;

            // all table rows' columns expected to have same width, so we take width of first row's columns as base-width for
            // future overlays for these columns
            const $firstRowWithData = $table.find('td').filter(':visible').first().closest('tr');
            const $firstRowColsWithData = $firstRowWithData.find('> td');


            $firstRowColsWithData.each(function (colIndex) {
                const $thisCol = $(this);

                const isLast = (colIndex === $firstRowColsWithData.length - 1);

                const currentColBoundingClientRect = $thisCol.get(0).getBoundingClientRect();

                const currentColLeftIndent = currentColBoundingClientRect.left - thisBoundingClientRect.left;

                // width of overlay for this particular column
                const currentColWidth = $thisCol.outerWidth();

                const $currentColOverlayEl = $(`<div class="${baseClassForOverlayEl} eq-${colIndex + 1}"></div>`);

                // if we need to have gap between .highlight-table-col-overlay elements
                const additionalLeftValue = (colIndex > 0 ? overlayElGap / 2 : 0);
                const toReduceWidthPx = overlayElGap / 2;
                // if we need to have gap between .highlight-table-col-overlay elements

                let finalWidth = currentColWidth - toReduceWidthPx;

                // checking if we need to increase width for last column-overlay
                // to match (cover) border-right for some sibling elements of last column-overlay
                // (currently - needed only for feature-overview tables - because it has complex border-styles styles)
                if (checkedTableWrapBorderWidth && isLast) {
                    finalWidth += checkedTableWrapBorderWidth;
                }

                $currentColOverlayEl.css({
                    'position': 'absolute',
                    'top': '0px',
                    'left': (currentColLeftIndent + additionalLeftValue) + 'px',
                    'height': tableContentHeight + 'px',
                    'width': finalWidth + 'px',
                });

                /*
                appending to $this element (to .highlight-table-cols parent wrapper),
                $this element must have the same width AND height as the table for whose columns we are adding overlays
                for overlays to have correct positioning and size
                */

                $currentColOverlayEl
                    .addClass(overlayElCustomClasses + (isLast ? ' last-item' : ''))
                    .appendTo($this);
            });

        });
    }


    $(document).on('ready', function () {

        // calling initializeHighlightOverlaysForTables() with delay so browser has more time to apply styles and the overlays will be built correctly
        setTimeout(function () {
            initializeHighlightOverlaysForTables();
        }, 1000);


        // calling initializeHighlightOverlaysForTables() again (without animations),
        // just in case (if user has slow network and DOM 'ready' event fired with unexpected delay, etc)
        setTimeout(function () {
            initializeHighlightOverlaysForTables(true);
        }, 4000);


        $(window).on('resize', function () {
            // always removing from DOM right after first resize - so user dont see highlight-overlays with incorrect sizes and position
            deleteHighlightOverlaysForTables();

            if (debounceResizeTimeout) {
                clearTimeout(debounceResizeTimeout)
            }

            debounceResizeTimeout = setTimeout(function () {
                // rebuilding highlight-overlays with (potentially) incorrect sizes and position with debounce on resize
                initializeHighlightOverlaysForTables();
            }, 200);

        })

    });


})(jQuery);